/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { authClusterUnsuspendOrg } from "../../funcs/authClusterUnsuspendOrg.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.UnsuspendClusterOrgRequest$inboundSchema,
};

export const tool$authClusterUnsuspendOrg: ToolDefinition<typeof args> = {
  name: "auth-cluster-unsuspend-org",
  description: `Unsuspend an organization`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await authClusterUnsuspendOrg(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
